import { SimpleHorseForSale } from "./HorseForSale";
import { LsysUser } from "./User";

export enum HorseMaleFemale {
    MALE = "MALE",
    FEMALE = "FEMALE"
}

export interface SimpleHorse {
    id: number;
    name: string;
    hipNumberName: string;
    referenced: boolean;

    colour?: HorseColour;
    gait?: HorseGait;
    sex?: HorseSex;

    sire?: SimpleHorse;
    dam?: SimpleHorse;
}

export interface Horse extends SimpleHorse {
    createdBy: LsysUser; //corresponds to user id

    registrationNumber: string;
    dateOfFoaling: number;
    embryoTransfer: boolean | null;
    microchipNumber: string;
    notes: string;

    sireOfDam?: SimpleHorse; //Todo Doble Check with Kevin sireOfDam
    sireChildren?: Array<SimpleHorse>;
    damChildren?: Array<SimpleHorse>;

    sales: Array<SimpleHorseForSale>;
}

export interface HorseColour {
    id: number;
    name: string;
    abbreviation: string;
}

export interface HorseGait {
    id: number;
    name: string;
    abbreviation: string;
}

export interface HorseSex {
    id: number;
    name: string;
    abbreviation: string;
    applicableFromAge: number;
    applicableToAge: number;
    maleFemale: HorseMaleFemale;
}



// WEBPACK FOOTER //
// ./src/model/Horse.ts